/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Free_VoicesInputs */

const en_settings_free_voices = /** @type {(inputs: Settings_Free_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free voices`)
};

const es_settings_free_voices = /** @type {(inputs: Settings_Free_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voces gratuitas`)
};

/**
* | output |
* | --- |
* | "Free voices" |
*
* @param {Settings_Free_VoicesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_free_voices = /** @type {((inputs?: Settings_Free_VoicesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Free_VoicesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_free_voices(inputs)
	return en_settings_free_voices(inputs)
});